import { InternalDatePickerProps } from '../components/FormInputs/DatePicker';
import { formatDateToApi } from './dates';

type TeceoDatePickerConfig = {
  valueFormatter: (date: Date | null) => string | null;
} & Pick<InternalDatePickerProps, 'size' | 'inputVariant' | 'fullWidth' | 'InputLabelProps'>;

const teceoDatePickerConfig: TeceoDatePickerConfig = {
  size: 'small',
  inputVariant: 'outlined',
  fullWidth: true,
  valueFormatter: formatDateToApi,
  InputLabelProps: {
    shrink: true,
  },
};

export default teceoDatePickerConfig;
